var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hero is-fullheight"},[_c('mainnav'),_vm._v(" "),_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('nuxt')],1)])],1),_vm._v(" "),_c('mainfooter'),_vm._v(" "),_c('browserBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }